import { render, staticRenderFns } from "./CardModalMobileMenu.vue?vue&type=template&id=13ff4f0a&scoped=true"
import script from "./CardModalMobileMenu.vue?vue&type=script&lang=js"
export * from "./CardModalMobileMenu.vue?vue&type=script&lang=js"
import style0 from "./CardModalMobileMenu.vue?vue&type=style&index=0&id=13ff4f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ff4f0a",
  null
  
)

export default component.exports